export default __webpack_public_path__ + "static/media/handle.9dc96a4a.png";